import React from "react";
import "./AppBar.css";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import useAuth from "../../../../hooks/useAuth";
import { Link } from "react-router-dom";
import "./AppBar.css";

const AppBar = () => {
  const { user, logout } = useAuth();
  return (
    <>
      <Navbar bg="dark" variant="dark" sticky="top" collapseOnSelect expand="lg">
        <Container>
          <Navbar.Brand href="#home">
            Medical 
            <span className="textBold ">
               PRESS
              <i className="fas fa-briefcase-medical bg-danger p-2 ms-2 rounded"></i>
            </span>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav.Link as={Link} to="/home">
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/doctors">
              Doctors
            </Nav.Link>
            <Nav.Link as={Link} to="/services">
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/gallery">
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/register">
              Register
            </Nav.Link>
        {user?.email ?
          <Button onClick={logout} variant="warning">Log Out </Button>:
          <Nav.Link as={Link} to="/login"> 
          Login
        </Nav.Link>}
            <Navbar.Text>
               <a href="#login" className="mx-3 link"> {user?.displayName}</a>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default AppBar;

{
  /* <div>
<Navbar sticky="top" bg="light" variant="light">
<Container>
<Navbar.Brand to="#home">Medical<span className="textBold ">PRESS<i className="fas fa-briefcase-medical bg-danger p-2 rounded"></i> </span> 

</Navbar.Brand>
<Navbar.Toggle aria-controls="responsive-navbar-nav" />
<Navbar.Collapse id="responsive-navbar-nav">
<Nav className="ms-auto">

<span className="mt-4 pt-1 me-2 text-secondary"><h5> {user.displayName} </h5> </span>
{user?.email && <button onClick=  {logout}  className="btn btn-danger small"> Log out </button>}


</Nav>
</Navbar.Collapse>
</Container>
</Navbar>
</div> */
}
